// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentsListColumns-VeloEmptyInfoIcon_cls1__iJCSd","cls2":"PaymentsListColumns-VeloEmptyInfoIcon_cls2__ZXHBg PaymentsListColumns-VeloEmptyInfoIcon_cls1__iJCSd"};